import React from 'react';
import './detailpage.css';

function Detailpage() {
  // Array of data representing your 4 distinct blocks
  const coursesData = [
    {
      id: 1,
      count: "6 Courses",
      title: "Programming Languages",
      className: "card-programming"
    },
    {
      id: 2,
      count: "6 Courses",
      title: "Idea Discussion",
      className: "card-idea"
    },
    {
      id: 3,
      count: "6 Courses",
      title: "Web Development",
      className: "card-web"
    },
    {
      id: 4,
      count: "6 Courses",
      title: "System Administration",
      className: "card-system"
    }
  ];

  return (
    <section className="fz-details-section">
      <div className="fz-details-grid-container">
        {coursesData.map((course) => (
          <div key={course.id} className={`fz-course-card ${course.className}`}>
            {/* Soft background image tint container built inside CSS */}
            <div className="card-image-tint-overlay" />
            
            {/* Card Content Elements */}
            <div className="card-inner-content">
              <span className="course-tag-count">{course.count}</span>
              <h3 className="course-card-title">{course.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Detailpage;